import axios from 'axios'
import qs from 'qs'

const clearTimeoutByUrl = (url, requestList) => {
  for (let item in requestList) {
    if (url === requestList[item]['url']) {
      clearTimeout(requestList[item]['timeId']);
    }
  }
}

axios.defaults.timeout = 50000; //响应时间
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; //配置请求头
axios.defaults.baseURL = ''; // 'http://localhost:63864/api/'; // 配置接口地址

axios._requestCount = 0; // 累加请求次数
axios._requestTimeIdList = [];
//POST传参序列化(添加请求拦截器)
axios.interceptors.request.use((config) => {

  axios._requestCount++;
  // 如果接口请求小于200ms的话 那么就不显示loading
  const timeId = setTimeout(() => {

  }, 100);
  axios._requestTimeIdList.push({
    timeId: timeId,
    url: config.url
  });

  //在发送请求之前做某件事  
  if (config.url != 'file.ashx' && config.method === 'post' && config.headers.post['Content-Type'] == 'application/x-www-form-urlencoded;charset=UTF-8') {
    config.data = qs.stringify(config.data);
  } else {
    //config.data = config.data;
  }


  return config;
}, (error) => {
  console.log('错误的传参')
  return Promise.reject(error);
});

//返回状态判断(添加响应拦截器)
axios.interceptors.response.use((res) => {
  axios._requestCount--;
  // clear 200ms 后准备展示的loading
  clearTimeoutByUrl(res.config.url, axios._requestTimeIdList);
  if (axios._requestCount <= 0) {
 
  }

  //对响应数据做些事
  if (!res.data.success) {
    return Promise.resolve(res);
  }
  return res;
}, (error) => {
  axios._requestCount--;
  clearTimeoutByUrl(error.config.url, axios._requestTimeIdList);
  if (axios._requestCount <= 0) { // 当全部的接口请求完毕后 关闭loading
   
  }

  console.log('网络异常')
  console.log(error)
  return Promise.reject(error);
});

//返回一个Promise(发送post请求)
export function fetchPost(url,) {
    return new Promise((resolve, reject) => {
    axios.post(url, params)
      .then(response => {
        resolve(response);
      }, err => {
        reject(err);
      })
      .catch((error) => {
        reject(error)
      })
  })
}
////返回一个Promise(发送get请求)
export function fetchGet(url, param) {
 
}

export default {
  fetchPost,
  fetchGet
}



// WEBPACK FOOTER //
// ./src/assets/http.js